import { NoResultsCard } from "@common/components";
import { Clock } from "@phosphor-icons/react";

export const ApplicationPending = () => {
  return (
    <NoResultsCard
      Icon={Clock}
      header="ApplicationPending"
      body={`Thanks for filling out our KYC form.\nYou'll be notified once the process ends.`}
    />
  );
};
